module.exports = __webpack_public_path__ + "static/media/mtech-time-table.7bfa5efd.pdf";